import {Group} from "../../lib/types";
import classNames from "classnames";

export const GroupName: React.FC<{ group: Group, space?:number, emojiClass?:string }> = ({ group, space=1, emojiClass="font-style-body-xxs" }) => {
  const groupName = group.name;
  return (
    <span className={classNames(
      "flex items-center ",
      `gap-${space}`
    )}><span className={emojiClass}>{group.emoji}</span> {groupName}</span>
  );
}